import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientQuery } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";

const INIT_STATE = {
    open: false,
    loading: false,
    statuses: [],
    loadingStatuses: false,
    workOrderTypes: [],
    loadingWorkOrderTypes: false,
    workOrderStatuses: [],
    loadingWorkOrderStatuses: false,
    customers: [],
    loadingCustomers: false,
}

const route = "modules/workOrders/views/schedule/modules/AdvanceFilter/redux/slice";

export const workOrdersTypeSchedule = createAsyncThunk(
    "workOrders/workOrdersSettingsSearchWorkOrderTypes/searchWorkOrderTypes",
    async ({ }, { rejectWithValue }) => {
        try {
            const response = await clientQuery(
                `
                query ($conditions: [WorkOrderTypeSearchInput], $sort: [WorkOrderTypeSortInput], $limit: Int, $offset: Int) {
                    data: searchWorkOrderTypes(
                        conditions: $conditions
                        sort: $sort
                        limit: $limit
                        offset: $offset
                    ) {
                        total
                        items {
                            id
                            name
                        }
                    }
                }
            `,{
                conditions: [],
                sort: {
                    field: "name",
                    order: "ASC"
                }
            },
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data?.items || [];
        } catch (error) {
            ExceptionManager(error, route, "searchWorkOrderTypes");
            return rejectWithValue(error);
        }
    }
);

export const workOrdersStatusSchedule = createAsyncThunk(
    "workOrders/workOrdersStatusSchedule/searchWorkOrderStatuses",
    async ({ }, { rejectWithValue }) => {
        try {
            const response = await clientQuery(
                `
                    query ($conditions: [WorkOrderStatusSearchInput], $sort: [WorkOrderStatusSortInput], $limit: Int, $offset: Int) {
                        data: searchWorkOrderStatuses(
                            conditions: $conditions
                            sort: $sort
                            limit: $limit
                            offset: $offset
                        ) {
                            total
                            items {
                                id
                                name
                                color
                            }
                        }
                    }
                `,
                {
                    conditions: [],
                    sort: {
                        field: "name",
                        order: "ASC"
                    }
                },
                endpoints.GRAPHQL_GENERAL_V2
            )

            return response?.data?.items || [];
        } catch (error) {
            ExceptionManager(error, route, "searchWorkOrderStatuses");
            return rejectWithValue(error);
        }
    }
);

export const workOrdersCustomerSchedule = createAsyncThunk(
    "workOrders/workOrdersCustomerSchedule/searchCustomers",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await clientQuery(
                `
            query ($conditions: [CustomerSearchInput], $sort: [CustomerSortInput], $limit: Int, $offset: Int) {
                    data: searchCustomers(
                        conditions: $conditions
                        sort: $sort
                        limit: $limit
                        offset: $offset
                    ) {
                        total
                        items {
                            id
                            name
                        }
                    }
                }
            `,
                {
                    conditions: payload?.conditions,
                    sort: {
                        field: "name",
                        order: "ASC"
                    },
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data?.items || [];
        } catch (exc) {
            ExceptionManager(exc, route, "searchCustomers");
            return rejectWithValue(exc);
        }

    }
)

const workOrdersScheduleAdvanceFilterRedux = createSlice({
    name: "workOrders/schedule/advanceFilter",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload
                ? { ...state, ...action.payload }
                : { ...INIT_STATE };
        },
        toggleModalWorkOrdersScheduleAdvanceFilter(state, action) {
            state.open = action.payload.open;
        },

    },
    extraReducers: (builder) => {
        //workOrdersTypeSchedule
        builder.addCase(workOrdersTypeSchedule.pending, (state) => {
            state.loadingWorkOrderTypes = true;
        });
        builder.addCase(workOrdersTypeSchedule.fulfilled, (state, action) => {
            state.loadingWorkOrderTypes = false;
            state.workOrderTypes = action.payload;
        });
        builder.addCase(workOrdersTypeSchedule.rejected, (state, action) => {
            state.loadingWorkOrderTypes = false;
            state.error = action.payload;
        });

        //workOrdersStatusSchedule
        builder.addCase(workOrdersStatusSchedule.pending, (state) => {
            state.loadingWorkOrderStatuses = true;
        });
        builder.addCase(workOrdersStatusSchedule.fulfilled, (state, action) => {
            state.loadingWorkOrderStatuses = false;
            state.workOrderStatuses = action.payload;
        });
        builder.addCase(workOrdersStatusSchedule.rejected, (state, action) => {
            state.loadingWorkOrderStatuses = false;
            state.error = action.payload;
        });

        //workOrdersCustomerSchedule
        builder.addCase(workOrdersCustomerSchedule.pending, (state) => {
            state.loadingCustomers = true;
        });
        builder.addCase(workOrdersCustomerSchedule.fulfilled, (state, action) => {
            state.loadingCustomers = false;
            state.customers = action.payload;
        });
        builder.addCase(workOrdersCustomerSchedule.rejected, (state, action) => {
            state.loadingCustomers = false;
            state.error = action.payload;
        });
    }
})

export const { actions, reducer } = workOrdersScheduleAdvanceFilterRedux;

export const { reset, toggleModalWorkOrdersScheduleAdvanceFilter } = actions;

export default reducer;